import { render, staticRenderFns } from "./DeliverableListTags.vue?vue&type=template&id=0c986b99&"
import script from "./DeliverableListTags.vue?vue&type=script&lang=js&"
export * from "./DeliverableListTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c986b99')) {
      api.createRecord('0c986b99', component.options)
    } else {
      api.reload('0c986b99', component.options)
    }
    module.hot.accept("./DeliverableListTags.vue?vue&type=template&id=0c986b99&", function () {
      api.rerender('0c986b99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableListTags.vue"
export default component.exports